import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import testimonial1 from '../../images/testimonial/t1.jpg'
import testimonial2 from '../../images/testimonial/t2.jpg'
import testimonial3 from '../../images/testimonial/t3.jpg'
import Quote from '../../images/testimonial/quote.svg'


const testimonials = [
    {
        id: '01',
        Des: "New Collection",
        Title: 'New Season',
        Sub: "",
        image: testimonial1,
    },
    {
        id: '02',
        Des: "New Collection",
        Title: 'New Season',
        Sub: "",
        image: testimonial2,
    },
    {
        id: '03',
        Des: "New Collection",
        Title: 'New Season',
        Sub: "",
        image: testimonial3,
    },


]

const Testimonial = (props) => {

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dots: true,
                    arrows: false,
                }
            },
        ]
    }


    return (
        <section className={"" + props.hclass}>
            <Slider {...settings} className="testimonial-slider">
                {testimonials.slice(0, 3).map((testimonial, item) => (
                    <div className="item" key={item}>
                        <div className="bg-image">
                            <img src={testimonial.image} alt="testimonial" />
                        </div>
                        <div className="content fade_bottom">
                            {/* <div className="icon">
                                <img src={Quote} alt="quote" />
                            </div> */}
                            <h3>{testimonial.Des}</h3>
                            <h4>{testimonial.Title}</h4>
                            <span>{testimonial.Sub}</span>
                        </div>
                    </div>
                ))}

            </Slider>
        </section>
    );
}

export default Testimonial;







